module.exports = __webpack_public_path__ + "static/media/groups.5a8b7c1a.svg";